<template>
  <MonacoEditor
    style="margin-top: 12px;overflow: hidden;"
    theme="vs"
    :options="monacoOptions"
    language="mustache"
    v-model:value="value"
    :width="width"
    :height="height"
    :data-qa="dataQa"
    :ref="refName"
    @change="change"
  ></MonacoEditor>
  <v-spacer></v-spacer>
  <div v-if="templateErrorMessage" style="color:var(--color-alert) !important" > {{ templateErrorMessage }} </div> 
</template>

<script lang="ts">
import MonacoEditor from 'monaco-editor-vue3';
import * as monaco from 'monaco-editor'
import { defineComponent } from "vue";
import { completionItems } from '../../utils/type.util';

export default defineComponent({
  name: "MustacheEditor",
  components: {
    MonacoEditor,
  },
  data() {
    return {
      value: '',
      templateErrorMessage: '',
      completionItems,
      monacoOptions: {
        scrollBeyondLastLine: false,
        colorDecorators: true,
        automaticLayout: true, // <<== the important part
        minimap: { enabled: false },
        wordWrap: 'on',
        lineNumbers: false,
        fixedOverflowWidgets: true,
        lineHeight: 24,
        tabSize: 2,
      },
    };
  },
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    dataQa: {
      type: String,
    },
    refName: {
      type: String,
    },
    owner: {
      type: String,
    },
    modelValue: {
      type: String,
    }
  },
  methods: {
    change(_value, _event): void {
      const model = monaco.editor.getModels()[0];

      const markers: monaco.editor.IMarkerData[] = [];

      const regex = /\{\{([^}]+)\}\}/g;
      const lines = _value.split('\n')?.map((line) => line?.trim());

      const invalidItems: string[] = [];

      for (const [index, line] of lines.entries()) {
        if (line.length > 0) {
          const items = line.match(regex);
          if (items) {
            for (const item of items.map(match => match.slice(2, -2))) {
              if (!this.completionItems.includes(item)) {
                const startColumn = line.indexOf(item) + 1;
                const endColumn = startColumn + item.length;
                invalidItems.push(item);
                markers.push({
                  startLineNumber: index + 1,
                  startColumn,
                  endLineNumber: index + 1,
                  endColumn,
                  message: "This item is not valid in template's replace",
                  severity: monaco.MarkerSeverity.Error,
                })
              }
            }
          }
        }
      }
      monaco.editor.setModelMarkers(model, this.owner, markers);
      if (invalidItems.length > 0) {
        this.templateErrorMessage = "Error. These items are not valid for template's replace: " + invalidItems.join(", ");
      } else {
        this.templateErrorMessage = "";
      }
      this.$emit("update:value", _value);
    }
  },
  watch: {
    modelValue(v) {
      this.value = v;
    }
  },
  mounted() {
    this.value = this.modelValue;
  }
});
</script>

<style>
.monaco-editor .margin { width: 0px!important; }

.monaco-editor .editor-scrollable { left: 0px!important; width: 100%!important; }

.monaco-editor .suggest-widget { width: 80%!important; max-width: 80%!important; left:5%!important; }
</style>
